import Icon from "@mkt/ui/components/common/Icon"

export default function ChevronRight(props) {
  return (
    <Icon
      iconMarkup={`
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.43359 1.19349L11.8814 7.87745C11.9544 7.94566 11.9544 8.08207 11.8814 8.21848L4.43359 15.1755" stroke="" stroke-width="1.02308" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `}
      iconName="ChevronRight"
      {...props}
    />
  )
}
